module.exports = __webpack_public_path__ + "static/pic4-7816794821c854718c17e1633a1ea186.jpg";